
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Statut d'ouverture en direct (heure de Paris) : 11h30 – 23h tous les jours, Douai le dimanche 18h30 – 23h ; chaque pastille suit son restaurant ---- */
  function parisMinutes(){
    try {
      var parts = new Intl.DateTimeFormat('fr-FR', {timeZone:'Europe/Paris', hour:'2-digit', minute:'2-digit', hourCycle:'h23'}).formatToParts(new Date());
      var h = 0, m = 0; parts.forEach(function(p){ if (p.type === 'hour') h = +p.value; if (p.type === 'minute') m = +p.value; });
      return h * 60 + m;
    } catch(e){ var d = new Date(); return d.getHours() * 60 + d.getMinutes(); }
  }
  // heure d'ouverture du jour (ou du lendemain), en minutes : 11h30, et 18h30 à Douai le dimanche ; lue aussi par les pages
  window.woodysOpen = function(r, tomorrow){
    var d;
    try { d = {Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6}[new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Paris', weekday:'short'}).format(new Date())]; } catch(e){ d = new Date().getDay(); }
    if (tomorrow) d = (d + 1) % 7;
    return r === 'douai' && d === 0 ? 1110 : 690;
  };
  function closeLabel(c){ c = c % 1440; return c === 0 ? 'minuit' : Math.floor(c / 60) + 'h' + (c % 60 ? ('0' + c % 60).slice(-2) : ''); }
  function lensLate(end, t){ var l = closeLabel(end); return end - t <= 30 ? {c:'soon', txt:'Lens · ferme bientôt · ' + l} : {c:'open', txt:'Lens ouvert · jusqu’à ' + l}; }
  function statusOf(r){
    var t = parisMinutes(), open = woodysOpen(r), close = 1380, late = r === 'lens' && window.woodysLate ? window.woodysLate() : null;
    if (late && late.yesterday && t < late.yesterday - 1440) return lensLate(late.yesterday - 1440, t);
    if (late && late.today && t >= open && t < late.today) return lensLate(late.today, t);
    if (t >= open && t < close){
      return close - t <= 30 ? {c:'soon', o:1, txt:'Ferme bientôt · 23h'} : {c:'open', o:1, txt:'Ouvert · ferme à 23h'};
    }
    if (t < open && open - t <= 30) return {c:'soon', txt:'Ouvre bientôt · ' + closeLabel(open)};
    return {c:'closed', txt:'Fermé · ouvre à ' + closeLabel(t < open ? open : woodysOpen(r, 1))};
  }
  // pastille sans restaurant (en-tête) : celui de la page, sinon le dernier choisi, sinon les deux ensemble
  function status(r){
    if (r === 'lens' || r === 'douai') return statusOf(r);
    var l = statusOf('lens'), d = statusOf('douai');
    if (l.txt === d.txt || l.txt.indexOf('Lens') === 0) return l;
    if (l.o && !d.o) return {c:l.c, txt:'Lens ouvert · Douai dès ' + closeLabel(woodysOpen('douai'))};
    return {c:l.c, txt:(l.c === 'soon' ? 'Lens ouvre bientôt · ' : 'Fermé · Lens ouvre à ') + closeLabel(woodysOpen('lens'))};
  }
  function restoOf(el){
    var v = el.getAttribute('data-status'), c;
    if (v === 'lens' || v === 'douai') return v;
    c = el.closest('[data-resto],[data-remember],[data-pick]');
    if (c) return c.getAttribute('data-resto') || c.getAttribute('data-remember') || c.getAttribute('data-pick');
    c = document.querySelector('[data-page-resto]');
    if (c) return c.getAttribute('data-page-resto');
    try { return localStorage.getItem('woodys-resto') || ''; } catch(e){ return ''; }
  }
  function paintStatus(){
    var memo = {};
    [].forEach.call(document.querySelectorAll('[data-status]'), function(el){
      var r = restoOf(el), s = memo[r] || (memo[r] = status(r));
      el.classList.remove('open', 'soon', 'closed'); el.classList.add(s.c);
      var sp = el.querySelector('span'); if (sp) sp.textContent = s.txt;
    });
  }
  paintStatus(); setInterval(paintStatus, 60000);

  /* ---- Bandeau de preuves : défilement continu, accéléré par le scroll ---- */
  var mq = document.querySelector('[data-marquee]');
  if (mq && !reduce){
    var track = mq.querySelector('.track');
    var clone = track.innerHTML; track.insertAdjacentHTML('beforeend', clone);
    [].slice.call(track.children).slice(track.children.length / 2).forEach(function(li){ li.setAttribute('aria-hidden', 'true'); });
    var x = 0, half = 0, vis = true, lastY = window.scrollY, boost = 0;
    function measure(){ half = track.scrollWidth / 2; }
    measure(); window.addEventListener('resize', measure);
    if ('IntersectionObserver' in window){ new IntersectionObserver(function(es){ vis = es[0].isIntersecting; }).observe(mq); }
    window.addEventListener('scroll', function(){ var y = window.scrollY; boost = Math.min(6, boost + Math.abs(y - lastY) * 0.04); lastY = y; }, {passive:true});
    (function tick(){
      if (vis && half){ x -= 0.6 + boost; boost *= 0.92; if (-x >= half) x += half; track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)'; }
      requestAnimationFrame(tick);
    })();
  }

  /* ---- La carte : rail horizontal piloté par le défilement vertical (ordinateur) ---- */
  var pin = document.querySelector('[data-rail]');
  if (pin){
    var vp = pin.querySelector('[data-rail-viewport]'), tr = pin.querySelector('[data-rail-track]'), bar = pin.querySelector('[data-rail-bar]');
    var desk = window.matchMedia('(min-width: 1024px)'), maxShift = 0;
    function layout(){
      if (desk.matches && !reduce){
        pin.classList.add('pinned');
        var sticky = pin.querySelector('.rail-sticky');
        maxShift = Math.max(0, tr.scrollWidth - vp.clientWidth + 2 * parseFloat(getComputedStyle(vp).paddingLeft));
        pin.style.height = (sticky.offsetHeight + maxShift) + 'px';
      } else {
        pin.classList.remove('pinned'); pin.style.height = ''; tr.style.transform = ''; maxShift = 0;
      }
      onRail();
    }
    function onRail(){
      var p;
      if (pin.classList.contains('pinned')){
        var r = pin.getBoundingClientRect(), total = pin.offsetHeight - pin.querySelector('.rail-sticky').offsetHeight;
        var hdr = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hdr')) || 72;
        p = total > 0 ? Math.min(1, Math.max(0, (hdr - r.top) / total)) : 0;
        tr.style.transform = 'translate3d(' + (-p * maxShift).toFixed(1) + 'px,0,0)';
      } else {
        var m = vp.scrollWidth - vp.clientWidth; p = m > 0 ? vp.scrollLeft / m : 0;
      }
      if (bar) bar.style.width = (12 + p * 88).toFixed(1) + '%';
    }
    var railTick = false;
    window.addEventListener('scroll', function(){ if (!railTick){ railTick = true; requestAnimationFrame(function(){ onRail(); railTick = false; }); } }, {passive:true});
    vp.addEventListener('scroll', onRail, {passive:true});
    window.addEventListener('resize', layout);
    [].forEach.call(tr.querySelectorAll('img'), function(im){ if (!im.complete) im.addEventListener('load', layout, {once:true}); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    layout();
  }

  /* ---- Woody suit le curseur du regard (Brand Book) ---- */
  var woodys = [].slice.call(document.querySelectorAll('.woody-live')).map(function(svg){
    return {svg:svg, p:[].slice.call(svg.querySelectorAll('.pupil')).map(function(c){ return {el:c, x:+c.getAttribute('cx'), y:+c.getAttribute('cy')}; })};
  });
  var MAX = 14, lastMove = Date.now();
  function look(w, dx, dy){ w.p.forEach(function(q){ q.el.setAttribute('cx', (q.x + dx).toFixed(2)); q.el.setAttribute('cy', (q.y + dy).toFixed(2)); }); }
  if (!reduce && woodys.length){
    window.addEventListener('pointermove', function(e){
      lastMove = Date.now();
      woodys.forEach(function(w){ var r = w.svg.getBoundingClientRect(); var cx = r.left + r.width * .66, cy = r.top + r.height * .76; var dx = e.clientX - cx, dy = e.clientY - cy; var d = Math.hypot(dx, dy) || 1; var k = Math.min(1, d / 220); look(w, dx / d * MAX * k, dy / d * MAX * k); });
    }, {passive:true});
    setInterval(function(){ if (Date.now() - lastMove < 3000) return; var a = Math.random() * Math.PI * 2, k = .4 + Math.random() * .6; woodys.forEach(function(w){ look(w, Math.cos(a) * MAX * k, Math.sin(a) * MAX * k); }); }, 3000);
  }

  /* ---- « Commander » : choix du restaurant, mémorisé pour la visite suivante ---- */
  var sheet = document.getElementById('order-sheet'), lastFocus = null;
  function getLast(){ try { return localStorage.getItem('woodys-resto'); } catch(e){ return null; } }
  function setLast(v){ try { localStorage.setItem('woodys-resto', v); } catch(e){} }
  function openSheet(e){
    if (e){ e.preventDefault(); }
    lastFocus = document.activeElement; var l = getLast();
    [].forEach.call(sheet.querySelectorAll('.choice'), function(c){ c.classList.toggle('last', c.dataset.pick === l); });
    paintStatus(); sheet.hidden = false; document.body.style.overflow = 'hidden';
    var first = sheet.querySelector('.choice.last') || sheet.querySelector('.choice'); if (first) first.focus();
  }
  function closeSheet(){ sheet.hidden = true; document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  [].forEach.call(document.querySelectorAll('[data-order]'), function(b){ b.addEventListener('click', openSheet); });
  [].forEach.call(sheet.querySelectorAll('[data-close]'), function(b){ b.addEventListener('click', closeSheet); });
  [].forEach.call(sheet.querySelectorAll('.choice'), function(c){ c.addEventListener('click', function(){ setLast(c.dataset.pick); setTimeout(closeSheet, 150); }); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });

})();


(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var header = document.getElementById('site-header');
  if (!header) return;
  var desk = window.matchMedia('(min-width: 1024px)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* ---- En-tête « collé » : ligne fine et logo réduit, sans changer la hauteur (aucun saut de page) ---- */
  function stuck(){ header.classList.toggle('stuck', window.scrollY > 2 && header.getBoundingClientRect().top <= 0.5); }
  window.addEventListener('scroll', stuck, {passive:true}); stuck();

  /* ---- Panneaux du menu (ordinateur) ---- */
  var mega = document.getElementById('mega'), scrim = document.getElementById('mega-scrim');
  var nav = document.getElementById('nav-main'), ind = nav.querySelector('.nav-ind');
  var items = [].slice.call(nav.querySelectorAll('.nav-item'));
  var withPanel = items.filter(function(it){ return it.dataset.panel; });
  var panels = {}, order = [];
  [].forEach.call(mega.querySelectorAll('.mega-panel'), function(p){ panels[p.dataset.panel] = p; order.push(p.dataset.panel); p.inert = true; });
  var cur = null, tOpen = 0, tClose = 0, openY = 0;
  function itemOf(name){ for (var i = 0; i < withPanel.length; i++){ if (withPanel[i].dataset.panel === name) return withPanel[i]; } return null; }

  function moveInd(it){
    if (!it){ ind.classList.remove('on'); return; }
    var l = it.querySelector('.nav-link').getBoundingClientRect(), n = nav.getBoundingClientRect();
    if (!ind.classList.contains('on')){ ind.style.transition = 'none'; }
    ind.style.setProperty('--x', (l.left - n.left).toFixed(1) + 'px');
    ind.style.setProperty('--w', l.width.toFixed(1) + 'px');
    ind.offsetWidth; ind.style.transition = ''; ind.classList.add('on');
  }

  // chargement différé des images des panneaux (au premier survol du menu)
  var warmed = false;
  function warm(){
    if (warmed) return; warmed = true;
    [].forEach.call(mega.querySelectorAll('img[loading="lazy"]'), function(im){ im.loading = 'eager'; });
  }

  function show(name){
    clearTimeout(tOpen); clearTimeout(tClose);
    if (name === cur) return;
    warm();
    var p = panels[name], prev = cur ? panels[cur] : null;
    var dir = prev ? (order.indexOf(name) > order.indexOf(cur) ? 1 : -1) : 0;
    if (prev){ prev.classList.remove('cur'); prev.inert = true; prev.style.transform = 'translateX(' + (-dir * 56) + 'px)'; }
    p.style.transition = 'none'; p.style.transform = 'translateX(' + (dir * 56) + 'px)';
    p.offsetWidth; p.style.transition = ''; p.style.transform = '';
    p.classList.add('cur'); p.inert = false;
    mega.style.height = p.offsetHeight + 'px';
    withPanel.forEach(function(it){ var on = it.dataset.panel === name; it.classList.toggle('open', on); it.querySelector('.nav-chev').setAttribute('aria-expanded', String(on)); });
    if (!cur) openY = window.scrollY;
    header.classList.add('mega-on'); scrim.classList.add('on');
    cur = name; moveInd(itemOf(name));
  }
  function hide(){
    clearTimeout(tOpen); clearTimeout(tClose);
    if (!cur) return;
    var p = panels[cur]; p.classList.remove('cur'); p.inert = true;
    mega.style.height = '0px';
    withPanel.forEach(function(it){ it.classList.remove('open'); it.querySelector('.nav-chev').setAttribute('aria-expanded', 'false'); });
    header.classList.remove('mega-on'); scrim.classList.remove('on');
    cur = null; moveInd(null);
  }

  items.forEach(function(it){
    it.addEventListener('pointerenter', function(e){
      if (e.pointerType !== 'mouse' || !desk.matches) return;
      warm(); clearTimeout(tClose); clearTimeout(tOpen);
      if (it.dataset.panel){
        if (cur) show(it.dataset.panel);
        else tOpen = setTimeout(function(){ show(it.dataset.panel); }, 110);   // petit délai : pas d'ouverture en passant
      } else {
        moveInd(it);
        if (cur) tClose = setTimeout(hide, 180);
      }
    });
    if (!it.dataset.panel) return;
    var chev = it.querySelector('.nav-chev'), link = it.querySelector('.nav-link');
    chev.addEventListener('click', function(){ if (cur === it.dataset.panel) hide(); else show(it.dataset.panel); });
    link.addEventListener('click', function(e){
      // écran tactile large (tablette en paysage) : 1er appui ouvre le panneau, 2e appui suit le lien
      if (!fine.matches && cur !== it.dataset.panel){ e.preventDefault(); show(it.dataset.panel); }
    });
  });
  nav.addEventListener('pointerleave', function(){ moveInd(cur ? itemOf(cur) : null); });
  [header.querySelector('.logo'), header.querySelector('.hdr-act')].forEach(function(el){
    if (el) el.addEventListener('pointerenter', function(e){ if (e.pointerType === 'mouse' && cur){ clearTimeout(tClose); tClose = setTimeout(hide, 180); } });
  });
  mega.addEventListener('pointerenter', function(){ clearTimeout(tClose); clearTimeout(tOpen); });
  header.addEventListener('pointerleave', function(e){ if (e.pointerType !== 'mouse') return; clearTimeout(tOpen); if (cur) tClose = setTimeout(hide, 260); });
  scrim.addEventListener('click', hide);
  header.addEventListener('focusout', function(e){ if (cur && !header.contains(e.relatedTarget)) hide(); });
  window.addEventListener('scroll', function(){ if (cur && Math.abs(window.scrollY - openY) > 40) hide(); }, {passive:true});
  window.addEventListener('resize', function(){ if (!desk.matches) hide(); else if (cur) { mega.style.height = panels[cur].offsetHeight + 'px'; moveInd(itemOf(cur)); } });

  /* ---- La carte : tuiles dont le bandeau devient un ruban rouge, entré par le côté de la souris ---- */
  [].forEach.call(mega.querySelectorAll('.ct-track[data-words]'), function(t){
    var words = t.dataset.words.split('|'), half = '';
    words.forEach(function(w){ var s = document.createElement('span'); s.className = 'ct-w'; s.textContent = w; half += s.outerHTML + '<i class="ct-dot"></i>'; });
    t.innerHTML = '<span class="ct-half">' + half + '</span><span class="ct-half">' + half + '</span>';
    t.style.animationDuration = (words.length * 2.6).toFixed(1) + 's';   // même vitesse de lecture quelle que soit la liste
  });
  [].forEach.call(mega.querySelectorAll('.ct'), function(li){
    var band = li.querySelector('.ct-band');
    function edge(e){ var r = li.getBoundingClientRect(); if (typeof e.clientX === 'number') band.style.setProperty('--from', e.clientX < r.left + r.width / 2 ? '-1' : '1'); }
    li.addEventListener('pointerenter', function(e){ edge(e); li.classList.add('on'); });
    li.addEventListener('pointerleave', function(e){ edge(e); li.classList.remove('on'); });
    li.addEventListener('focusin', function(){ li.classList.add('on'); });
    li.addEventListener('focusout', function(){ li.classList.remove('on'); });
  });

  /* ---- Menu plein écran (mobile, tablette) ---- */
  var mbtn = document.getElementById('menu-btn'), mm = document.getElementById('m-menu'), lbl = mbtn.querySelector('.mb-lbl');
  var behind = [document.querySelector('main'), document.querySelector('.site-foot'), document.querySelector('.club-bar'), document.getElementById('notes-toggle')];
  var tHide = 0;
  function openMenu(){
    clearTimeout(tHide);
    // le bandeau du club défile hors de l'écran : l'en-tête se cale en haut, le menu commence juste dessous
    var ht = header.getBoundingClientRect().top;
    if (ht > 0.5) window.scrollTo({top: window.scrollY + ht, left: 0, behavior: 'instant'});
    var r = mbtn.getBoundingClientRect();
    mm.style.setProperty('--cx', (r.left + r.width / 2).toFixed(0) + 'px');
    mm.style.setProperty('--cy', (r.top + r.height / 2).toFixed(0) + 'px');
    mm.style.setProperty('--mtop', Math.max(0, header.getBoundingClientRect().bottom).toFixed(0) + 'px');
    mm.hidden = false; mm.offsetWidth; mm.classList.add('on');
    header.classList.add('menu-open'); mbtn.setAttribute('aria-expanded', 'true'); lbl.textContent = 'Fermer';
    document.documentElement.style.overflow = 'hidden';
    behind.forEach(function(el){ if (el) el.inert = true; });
  }
  function closeMenu(back){
    if (!mm.classList.contains('on')) return;
    mm.classList.remove('on');
    header.classList.remove('menu-open'); mbtn.setAttribute('aria-expanded', 'false'); lbl.textContent = 'Menu';
    document.documentElement.style.overflow = '';
    behind.forEach(function(el){ if (el) el.inert = false; });
    tHide = setTimeout(function(){ if (!mm.classList.contains('on')) mm.hidden = true; }, reduce ? 0 : 600);
    if (back) mbtn.focus();
  }
  mbtn.addEventListener('click', function(){ if (mm.classList.contains('on')) closeMenu(); else openMenu(); });
  [].forEach.call(mm.querySelectorAll('.mm-item.acc > .mm-row'), function(b){
    b.addEventListener('click', function(){
      var li = b.parentNode, on = !li.classList.contains('open');
      [].forEach.call(mm.querySelectorAll('.mm-item.acc'), function(o){
        var open = (o === li) && on;
        o.classList.toggle('open', open); o.querySelector('.mm-row').setAttribute('aria-expanded', String(open)); o.querySelector('.mm-sub').inert = !open;
      });
    });
  });
  // un lien vers une section de la page referme le menu
  mm.addEventListener('click', function(e){ var a = e.target.closest('a[href^="#"]'); if (a) closeMenu(); });
  desk.addEventListener('change', function(){ if (desk.matches) closeMenu(); });

  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    if (cur){ var it = itemOf(cur); hide(); if (it) it.querySelector('.nav-chev').focus(); }
    else if (mm.classList.contains('on')) closeMenu(true);
  });

  /* ---- « Commander » : affiche le restaurant retenu ---- */
  var where = header.querySelector('[data-where]');
  function getLast(){ try { return localStorage.getItem('woodys-resto'); } catch(e){ return null; } }
  function paintWhere(){ var v = getLast(); where.textContent = v === 'lens' ? 'Lens' : v === 'douai' ? 'Douai' : ''; }
  paintWhere();
  document.addEventListener('click', function(e){
    var r = e.target.closest && e.target.closest('[data-remember]');
    if (r){ try { localStorage.setItem('woodys-resto', r.dataset.remember); } catch(err){} }
    if (r || (e.target.closest && e.target.closest('.choice'))) setTimeout(paintWhere, 0);
  });

})();
